import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import VenueList from "./VenueList";
import { ModalPickerProps } from "../props";
import RemovableVenue from "components/Removables/RemovableVenue";
import CompanyNewModal from "company/new/App";

const VenueModalPicker = (props: ModalPickerProps<server.dto.VenueSmall>) => {
  const [displayNewCompanyModal, setDisplayNewCompanyModal] = React.useState(false);

  return <>
    {displayNewCompanyModal && <CompanyNewModal
      onClose={() => setDisplayNewCompanyModal(false)}
      onCreated={(c) => {
        props.onChange({
          venueId: c.companyId,
          name: c.name,
          cityCountry: [c.address.city, c.address.countryName].filter(Boolean).join(", "),
          location: c.geoCode.location,
          isValidated: c.isValidated
        });
        setDisplayNewCompanyModal(false);
      }}
      defaults={{
        isVenue: true
      }}
      disableVenue
    />}
    <ModalPickerWithChooseButton
      canCreateNew={props.canCreateNew}
      onNewClicked={() => setDisplayNewCompanyModal(true)}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={site.currentEnvironment.functionGroups.venue.plural}
      modalSize="tiny"
      value={props.value}
      renderModalContent={(closeModal) => <VenueList
        onItemSelected={(venue) => {
          closeModal();
          props.onChange(venue);
        }}
      />}
      renderRemovable={(props) => <RemovableVenue {...props} />}
      {...props}
    />
  </>
};

export default VenueModalPicker;